// All 45 public Google reviews visible on 2026-09-20. Long reviews use short excerpts; blank text means a rating-only review.
window.UNJHA_REVIEWS = [
  {
    "name": "Yash Manchanda",
    "text": "The fragrance, flavor, and freshness of their products are truly exceptional. Their reasonable pricing makes it even better.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjVPUDgXNCOKdBCXEqpvnFodAZwRzPN9oLry0bb9InqOYBlx-K5oVA=s64-c-rp-mo-ba12-br100",
    "url": "https://www.google.com/maps/contrib/109539259037897090545/reviews?hl=en"
  },
  {
    "name": "MONISHA C",
    "text": "Excellent aroma and rich flavor! Authentic spices with amazing freshness with Good and neat packaging",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocKcTvQr55uuA2t0W06V3G2k7SUmuvxbNxDBhoJ_0O2WntetHw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/111929596004079513537/reviews?hl=en"
  },
  {
    "name": "ashok varma",
    "text": "The freshness, aroma, and authenticity of their Indian blends—like garam masala, turmeric, and cumin—elevate every dish.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjXpB7SN-Ou9l3AindegSOPJAFzApbcGOC9lqXCc-DYlTeCmv2wF=s64-c-rp-mo-ba12-br100",
    "url": "https://www.google.com/maps/contrib/104597023527570544636/reviews?hl=en"
  },
  {
    "name": "Pankaj Thakker",
    "text": "The aroma, taste, and quality are top-notch, and the pricing is unbeatable. Truly evergreen products that keep our cooking flavorful!",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWwBaflAAjhSx4lFwZVGZxav8__WYBNK-GMcumjO_yxOpaAePRd=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/108746825115845931012/reviews?hl=en"
  },
  {
    "name": "Raj Goswami",
    "text": "All the spices are excellent in quality. Very pure and clean, Looks and tastes very fresh and natural.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjX_8d7nvUJ5xRpBp_v380Wa1LmSlrhKL_Ddr8UP3pXhOwUMAEl8=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/100686186717467948867/reviews?hl=en"
  },
  {
    "name": "Rabiya Mukri",
    "text": "Very clean , fresh, traditional and authentic flavours, which bring out the traditional taste in your food.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJE7fDBwJuXIVVSJi92U1ZWvmp78ci3Xym3mg35gHp6xBqeng=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/107413511678000459648/reviews?hl=en"
  },
  {
    "name": "Amber Datt",
    "text": "Wonderful taste and quality! Very traditional and authentic flavours which make you feel like home!",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjW03EgFcH0djQ5oqOK8g0MZBWlIHh6xw4Z8vPg5q27UDcP5iClI=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/109176674966731948979/reviews?hl=en"
  },
  {
    "name": "RAVI DAVE",
    "text": "One of the premium brand ,very high quality of products with great prices ! I highly recommend their very professional service !",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocKh_MJdDY-RLy9ujw-viadKFrMlAov3oXCR6rS6j5W4E95hTA=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/104774032755882975439/reviews?hl=en"
  },
  {
    "name": "Charu Patel",
    "text": "Grate place to get the Indian spices,, excellent quality, fresh n authentic. Good flavour n taste.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocIpAjX5rleZyexkf_-zR3gYiZxahWy4F49i2CUdbWGo4JWBiw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/109175595865845448455/reviews?hl=en"
  },
  {
    "name": "Arvind Chaudhari",
    "text": "The spices are very authentic with no artificial additives. The quality is excellent. Looks and tastes very fresh and natural.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLQ3ETn-MyWiOeLz62TJOu7EQ5lMEp8T1xILbfmTdHVaZoJaw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/114466326817674293653/reviews?hl=en"
  },
  {
    "name": "Mayur Ahir",
    "text": "Great Indian spices with excellent quality and wonderful taste. Products are fresh and affordable in price.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjUMz4YaI9RTpJ0jhUwERRqXBx7cQqxX93sTU-e713SJ9fhUJBre=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/111122477063971424245/reviews?hl=en"
  },
  {
    "name": "Dharini Shah",
    "text": "All spices are excellent quality, fresh and good in taste. Good customer service. Highly recommend to buy from here.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWO-j5nrmJ7qrGDNpj4AFrCVG7D0BqRSuUGO3-75y3Tr8fsV5-Drw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/116986114626637884173/reviews?hl=en"
  },
  {
    "name": "Parul K",
    "text": "All the spices are excellent in quality.very pure and clean. Testes very fresh and natural.price also Good . I highly recommend it.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjVtEfVPrLF7xx03tQ67TW_vS9VeqAa2aHagMYm5Pk_WoOT-M-Ay=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/106457779046385088684/reviews?hl=en"
  },
  {
    "name": "Chetna Naik",
    "text": "Great indian spices directly from home!! Very fresh and reasonable. Great customer service and very friendly approach!",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJezgA0a1SI5n2U_jBC92lKptk7oZvOfvPsB2frCz18gDmB1Q=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/103818323998125057441/reviews?hl=en"
  },
  {
    "name": "Parul Patel",
    "text": "All of the Spices are excellent in quality, natural and fresh. Unjha special traditional and authentic. Highly recommend.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLVG9gjGeOhLa0l8r9fIUKzDjInwxJRoU9L440rm5uyacLkDw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/102509893275654121561/reviews?hl=en"
  },
  {
    "name": "soni Amit",
    "text": "Authentic Indian spices with excellent price and packaging. Most definitely recommended.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJPjmNuA99J3fJ3ilRmXKW7JogIPHSVIDDNYomQYp-nUuqylQ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/116137958277894352799/reviews?hl=en"
  },
  {
    "name": "Asha Pillai",
    "text": "Great products very fresh and good services. Fresh spices at a very reasonable price and delivered.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocKX3T9gNkjLWdrVSlVErqquyVQ_F65AIWn7DIpTGiq_iQ7nb84=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/104835691628422012488/reviews?hl=en"
  },
  {
    "name": "Sejal Pancholi",
    "text": "Great products and services. Pure spices at a very reasonable price.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjUr11bTRjVT60P2HkiVcUqGv62MCe-AMSmI03Q_AeouDGOgPVw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/110706665805584436133/reviews?hl=en"
  },
  {
    "name": "H P",
    "text": "Best place to get all your spices, excellent quality. Highly recommended.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocI_k2KOhbCFEnw9JWjyogCRqMvAHVP2rtw9mhNMl8JAFMZFKA=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/112514265873896360409/reviews?hl=en"
  },
  {
    "name": "Yogesh",
    "text": "Very clean products at very reasonable price. No need to order from India.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWNFFNle2OdSaVBfdjgJ3kWBQwdnuN0SFBOJfPC-Yp7UIA8fNU=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/103401364656110204497/reviews?hl=en"
  },
  {
    "name": "Riya P",
    "text": "high quality spices that don't have excess debris, and that are reasonably priced. Will buy from here again!!",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocID0JrVn-dXfaPwdBDyD3duTtaUb-xaIwX3IFcxcz0qjI47Sg=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/111065736700018280382/reviews?hl=en"
  },
  {
    "name": "Harry Soni",
    "text": "Indian Unjha spices super se upper. We are lucky to have farm fresh quality Unjha spices directly from Unjha.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocIn7fFSjn2QITYfdXQJMJIL2h4X1kg3dLolnD7BA_eCfkxxXIBZ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/118222603754219892569/reviews?hl=en"
  },
  {
    "name": "Bhavna Soni",
    "text": "Super quality Indian spices highly recommended. Good customer service.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWSwJgFdjMICVJf4W3DaR6EHXpC0Dmq4xIp1Qj26LRGvoQTae3EZg=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/116098016786538278510/reviews?hl=en"
  },
  {
    "name": "nisha saheba",
    "text": "Test like an Indian spice, clean and effort able price no need to buy from India 👍",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjXiWFn6wJPNDTXp8Rqg3rGmgAEnIglKwBur0_9mHdCZRsRh3vFe=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/116253912187455409981/reviews?hl=en"
  },
  {
    "name": "Priti Bar",
    "text": "I orders masala and so many species and all looks and taste so fresh.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJyNuwsCZ96Tcj6eh80DuwR-PAiKPDFb-uEBxeNLPIqbDQ4DuOx=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/103837708102595774686/reviews?hl=en"
  },
  {
    "name": "Varsha Patel",
    "text": "Items were received very quickly and efficiently. They were also fresh and tasted very nice.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocK82Roe_s2vC6aEZJ4I46BgMbb5s4micdkjfsUjmofytv3Deg=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/112224810808538546835/reviews?hl=en"
  },
  {
    "name": "Pradeep Parikh",
    "text": "Yes… All stuff is of good quality as well as nice service. I appreciate it. Thanx 🙏",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWszjwTSNeWeTqq6huZJ7W4lLFou6vndOWX5cK9ptn8jtZt4WX4hQ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/109717169482106772746/reviews?hl=en"
  },
  {
    "name": "D Patel",
    "text": "Great quality masalas and excellent customer service. Highly recommended products. Thanks",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWNdxe5xBHzloMmsV4CG3IdnzKJWC6Dl7KFJIRGT1ruRVqKdqaU=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/100516499394973617784/reviews?hl=en"
  },
  {
    "name": "Satyendra Patel",
    "text": "Quality products and packing. Best price and excellent customer service.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocKLRUlTsjth9hXSVuPfd4tZWNwBv1G0eTMoDd94AvDSaPJLqQ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/105687404439742605510/reviews?hl=en"
  },
  {
    "name": "Zalak Patel",
    "text": "It’s really nice product, 100% satisfied",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjWr61JjmIJ50P90U6ge9CpjAQCTRRJ4Aj6SDO4Bsu5x_gGc-X_i=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/100575618474256028685/reviews?hl=en"
  },
  {
    "name": "Dhrumil Soni",
    "text": "Excellent quality. Traditional Indian food",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJUnMsYvfpnJwDJDCqK77Gzmf_OHRSCAn9eiVyO1lhhh8oXhPk=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/101854307982128197964/reviews?hl=en"
  },
  {
    "name": "nevil patel",
    "text": "Authentic spices straight from India.Honestly I can feel the difference.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJFVoRLEGCXtNScFWjDaB3duDuZc57WfQXAUms2HAViSijV0w=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/106489575854280201682/reviews?hl=en"
  },
  {
    "name": "Rush Shaw",
    "text": "Best spices in town, made my eyes tear up.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocKKEsqve-q-PtAz1RCmi16qSVowVXgBwiCwMHnw4T3iTMLiSQ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/109404306544754863171/reviews?hl=en"
  },
  {
    "name": "Mitali Thakore",
    "text": "Best quality and service. Worth buying!!",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJGg5duQBsell95iFCQpGX555EnS7nv63HIUZkmHHevKNVpIA=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/117329684502220975684/reviews?hl=en"
  },
  {
    "name": "ektaben devani",
    "text": "Excellent quality and fresh.I strongly recommend it.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLrdzVAo3v4BB9Z9OrXU6wX7qMWvi1Hxm365A1KFDREI2_I=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/106472054017677417099/reviews?hl=en"
  },
  {
    "name": "Harsh Patel",
    "text": "Excellent products. I strongly recommend to buy.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjXOuv85lcHsSYADxrXiFaqfvSRG2d30uvnFlynZtAj0r_3577kB=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/100531951517985433791/reviews?hl=en"
  },
  {
    "name": "Nimisha Patel",
    "text": "Fresh and excellent quality spices.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocIYD70iDIsiN0mYRBWBvZeDGjwxRZ1dNpRWrCVOfqGKLz4BAg=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/100562126845218966427/reviews?hl=en"
  },
  {
    "name": "BurlingtonDental Net",
    "text": "Fresh. Good Quality. Will buy again.",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a-/ALV-UjXS5RTy_BYt8Gt2XXUUWA1f4xW3_TAAql9_oU4fzo2-JEA6T-E0=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/111047176927042944226/reviews?hl=en"
  },
  {
    "name": "Hetal Shah",
    "text": "Excellent products love it",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLzDq8fZkDAkCv7uvikUP1LIq12r9M5epCKdraUIjNt9I1q0A=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/117235061796360902792/reviews?hl=en"
  },
  {
    "name": "MAULIK DESAI",
    "text": "Excellent quality and great customer service",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJF0_ex5ycSRRg-3FHmHhcPF2Zr821bwUuk-Fk1aH5CqkHCnw=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/101435355776500354527/reviews?hl=en"
  },
  {
    "name": "jignasa amin",
    "text": "The best product 👌",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLLkfKRM45-9ACdeDYINccuCshlZIotAW6CyQ_uIWRujhgsDQ=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/113887790593273455297/reviews?hl=en"
  },
  {
    "name": "VENUS PATEL",
    "text": "",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocIeCXzSrYnBeQ5nz3Jrhl31JHm34Qj2hr52gPGEUVok01GXcg=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/115476953926082443187/reviews?hl=en"
  },
  {
    "name": "jay pat",
    "text": "",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocK9G13ET1fbpNr6YKJ7fDiejWOAIyHJuX_mif5a5cYnB46-Ig=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/101488268611295480595/reviews?hl=en"
  },
  {
    "name": "Pinal Shah",
    "text": "",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocJJDu1l7Ytfluyf4vvnlE2vpIjG3mEkvJ3VPQeJb1OajmgO2Q=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/117861646933370697349/reviews?hl=en"
  },
  {
    "name": "Neepurvee Neepurvee",
    "text": "",
    "rating": 5,
    "photo": "https://lh3.googleusercontent.com/a/ACg8ocLallUV01JWGtGdRN_XA-o83Kp-MDCepMTd1PE3mHQcJXNhgA=s64-c-rp-mo-br100",
    "url": "https://www.google.com/maps/contrib/116691433249721043106/reviews?hl=en"
  }
];
